import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageMainTitle, ResourcesLoader, redirectTo } from 'omni-package-react-core';
import { useScopedSelector } from 'ia-react-core';
import Tabs from './Tabs';
import { getTabName } from './utils/securedMessagingHelper';
import { SecuredMessagingState } from '../../interfaces/SecuredMessagingState';
import {
  StyledPage,
  StyledRow,
  StyledRightCol,
  StyledBox,
  StyledPrimaryButton,
  StyledLeftCol,
} from './SecuredMessagingPage.styles';
import Constants from '../../Constants';
import MessagingSummaryResource from '../../components/MessagingSummaryResource';

export interface SecuredMessagingPageProps {
  children?: ReactNode;
}

const SecuredMessagingPage: FC<SecuredMessagingPageProps> = (props) => {
  const { t } = useTranslation('SecureMessagingPage');
  const navigate = useNavigate();
  const activeTab: number = useScopedSelector((state: SecuredMessagingState) => state.messagesTabs?.selectedTab);
  const canWrite: boolean = useScopedSelector((state: SecuredMessagingState) => state.messages?.canWrite);
  const messageSource = getTabName(activeTab);
  const messagesPerPage = 10;
  return (
    <ResourcesLoader reloadEveryTime validateAuthorization validateAvailability>
      <ResourcesLoader.Resources>
        <MessagingSummaryResource />
      </ResourcesLoader.Resources>
      <ResourcesLoader.Content>
        <StyledPage {...props}>
          <StyledRow>
            <StyledLeftCol xs={12} sm={6}>
              <PageMainTitle data-testid="SecuredMessagingPageMainTitle">
                {t('title')}
              </PageMainTitle>
            </StyledLeftCol>
            <StyledRightCol xs={12} sm={6}>
              {canWrite &&
                <StyledPrimaryButton
                  data-testid="securedMessagingNewMessageButton"
                  onClick={() => {
                    redirectTo(`${Constants.NewMessagePagePath}?messageSource=${messageSource}`, navigate);
                  }}
                >
                  {t('sendMessageButton')}
                </StyledPrimaryButton>}
            </StyledRightCol>
          </StyledRow>
          <StyledBox>
            <Tabs messagesPerPage={messagesPerPage} canWrite={canWrite} />
          </StyledBox>
        </StyledPage>
      </ResourcesLoader.Content>
    </ResourcesLoader>
  );
};
export default SecuredMessagingPage;
